import { render, staticRenderFns } from "./product_category.vue?vue&type=template&id=1c0054e4&scoped=true&"
import script from "./product_category.vue?vue&type=script&lang=js&"
export * from "./product_category.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0054e4",
  null
  
)

export default component.exports